<!-- src/components/StaffCardMinor.svelte -->
<script>
  export let imageSrc = "";
  export let title = "";
  export let description = "";
  export let alt = "Staff member";
</script>

<div
  class="
    w-[190px]
    overflow-hidden
    rounded-xl
    bg-blue-50 /* light tinted background */
    shadow-md /* soft elevation */
    text-center
  "
>
  {#if imageSrc}
    <img
      src={imageSrc}
      {alt}
      class="w-[190px] h-[190px] object-fill rounded-xl"
      width="190"
      height="190"
      loading="lazy"
    />
  {/if}

  <div class="px-3 pt-4 pb-5">
    {#if title}
      <h3 class="text-lg font-bold text-gray-900 leading-tight">
        {title}
      </h3>
    {/if}

    {#if description}
      <p class="mt-2 text-sm text-gray-900 leading-snug">
        {description}
      </p>
    {/if}
  </div>
</div>
